var exports = {
  "q": "enrollCommand__eEFaY",
  "x": "enrollButton__eEFaY",
};

module.exports = exports;
